module.exports = __webpack_public_path__ + "static/media/venue-1.6c4d63cd.jpg";